import {sendRequest, urls} from '../../apiRequestService';
import {requestMethod, responseType} from '../../globalConstants';
import {IProductsData} from './types';

export const getProducts = (data: IProductsData) => {
    return sendRequest(urls.PRODUCTS, requestMethod.POST, responseType.JSON, data);
};
